import { DatasetStep } from "./steps/DatasetStep.jsx";
import { FiltersStep } from "./steps/FiltersStep.jsx";
import { SessionsStep } from "./steps/SessionsStep.jsx";
import { CalculatedFieldsStep } from "./steps/CalculatedFieldsStep.jsx";
import { GroupingStep } from "./steps/GroupingStep.jsx";
import { MetricsStep } from "./steps/MetricsStep.jsx";
import { VisualizationStep } from "./steps/VisualizationStep.jsx";
import { SaveStep } from "./steps/SaveStep.jsx";

export function ReportBuilderConfigPanel({ vm, c, dark, A }) {
  const fields = vm.dataset?.fields ?? [];

  switch (vm.step) {
    case "dataset":
      return (
        <DatasetStep
          datasets={vm.datasets}
          datasetsLoading={vm.datasetsLoading}
          datasetId={vm.datasetId}
          onSelect={vm.setDatasetId}
          c={c}
          A={A}
        />
      );
    case "filters":
      return (
        <FiltersStep
          filters={vm.filters}
          filterLogic={vm.filterLogic}
          fields={fields}
          onAdd={vm.addFilter}
          onUpdate={vm.updateFilter}
          onRemove={vm.removeFilter}
          onLogicChange={vm.setFilterLogic}
          c={c}
          A={A}
          dark={dark}
        />
      );
    case "sessions":
      return (
        <SessionsStep
          session={vm.session}
          onStartQueryChange={vm.setSessionStartQuery}
          onEndQueryChange={vm.setSessionEndQuery}
          fieldNames={fields}
          c={c}
          A={A}
          dark={dark}
        />
      );
    case "fields":
      return (
        <CalculatedFieldsStep
          calculatedFields={vm.calculatedFields}
          fieldNames={fields}
          onAdd={vm.addCalculatedField}
          onUpdate={vm.updateCalculatedField}
          onRemove={vm.removeCalculatedField}
          onAddLogic={vm.addFieldLogic}
          onUpdateLogic={vm.updateFieldLogic}
          onRemoveLogic={vm.removeFieldLogic}
          c={c}
          A={A}
          dark={dark}
        />
      );
    case "grouping":
      return (
        <GroupingStep
          fields={fields}
          groupBy={vm.groupBy}
          metricsCount={vm.metrics.filter((m) => m.field).length}
          onToggle={vm.toggleGroupBy}
          c={c}
          A={A}
        />
      );
    case "metrics":
      return (
        <MetricsStep
          metrics={vm.metrics}
          fields={fields}
          onAdd={vm.addMetric}
          onAddPreset={(presetId) => vm.addMetricFromPreset(presetId, fields)}
          onUpdate={vm.updateMetric}
          onRemove={vm.removeMetric}
          onClone={vm.cloneMetric}
          onMove={vm.moveMetric}
          stepError={vm.step === "metrics" ? vm.stepError : null}
          c={c}
          A={A}
          dark={dark}
        />
      );
    case "visual":
      return <VisualizationStep visualization={vm.visualization} onSelect={vm.setVisualization} c={c} A={A} />;
    case "save":
      return (
        <SaveStep
          reportName={vm.reportName}
          onNameChange={vm.setReportName}
          onSave={vm.handleSave}
          saving={vm.saving}
          saveSuccess={vm.saveSuccess}
          saveError={vm.saveError}
          stepError={vm.step === "save" ? vm.stepError : null}
          estimate={vm.estimate}
          c={c}
          A={A}
          dark={dark}
        />
      );
    default:
      return null;
  }
}
